import React, { useRef, useState } from "react";
import "./OtpInput.css";

function OtpInput({ length = 6, onComplete }) {
	const [otp, setOtp] = useState(new Array(length).fill(""));
	const inputsRef = useRef([]);

	const handleChange = (index, e) => {
		const value = e.target.value;

		if (!/^\d*$/.test(value)) return;

		const newOtp = [...otp];
		newOtp[index] = value.slice(-1);
		setOtp(newOtp);

		if (value && index < length - 1) {
			inputsRef.current[index + 1].focus();
		}

		if (newOtp.every((digit) => digit !== "")) {
			onComplete?.(newOtp.join(""));
		}
	};

	const handleKeyDown = (index, e) => {
		if (e.key === "Backspace") {
			if (index > 0) {
				inputsRef.current[index - 1].focus();
			}
			const newOtp = [...otp];
			newOtp[index] = "";
			setOtp(newOtp);
		} else if (e.key === "ArrowLeft" && index > 0) {
			inputsRef.current[index - 1].focus();
		} else if (e.key === "ArrowRight" && index < length - 1) {
			inputsRef.current[index + 1].focus();
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const paste = e.clipboardData.getData("text").replace(/\D/g, "");

		if (paste.length === 0) return;

		const newOtp = paste.slice(0, length).split("").concat(
			new Array(Math.max(0, length - paste.length)).fill("")
		);

		setOtp(newOtp);

		const nextFocus = Math.min(paste.length, length - 1);
		inputsRef.current[nextFocus].focus();

		if (newOtp.every((digit) => digit !== "")) {
			onComplete?.(newOtp.join(""));
		}
	};

	return (
		<div className="otp-wrapper">
			<div className="otp-container" onPaste={handlePaste}>
				{otp.map((digit, index) => (
					<div className={`otp-input-wrapper ${digit ? "filled" : ""}`}>
						<input
							key={index}
							type="text"
							maxLength="1"
							value={digit}
							ref={(el) => (inputsRef.current[index] = el)}
							onChange={(e) => handleChange(index, e)}
							onKeyDown={(e) => handleKeyDown(index, e)}
							onFocus={(e) => e.target.select()}
							className={`otp-input ${digit ? "filled" : ""}`}
							autoFocus={index === 0}
						/>
					</div>
				))}
			</div>
		</div>
	);
}

export default OtpInput;